/*
  Photo gallery lightbox.
  Markup and the reasoning behind it: sections/photo-gallery.liquid

  Reads each photo off its figure's data- attributes rather than from a second
  Liquid loop, so the grid and the lightbox can never drift apart.

  Degrades honestly. If <dialog> is missing or this file never loads, the
  triggers are still buttons inside a working grid — nothing is hidden behind
  JavaScript that was not already visible.
*/
(function () {
  'use strict';

  // The script tag is emitted per section, so a page with two galleries loads
  // it twice. Registration happens once; init is idempotent per root anyway.
  if (window.__shikraPhotoGallery) return;
  window.__shikraPhotoGallery = true;

  /*
    Two namespaces on purpose: data-pg-* carries each photo's payload on its
    figure, data-pg-lb-* marks the elements inside the dialog. They were the
    same prefix at first, which made an unscoped querySelector('[data-pg-link]')
    silently match a figure instead of the lightbox's button.
  */
  function collect(root) {
    return Array.prototype.map.call(root.querySelectorAll('.pg__item'), function (fig) {
      return {
        src: fig.dataset.pgSrc || '',
        srcset: fig.dataset.pgSrcset || '',
        alt: fig.dataset.pgAlt || '',
        caption: fig.dataset.pgCaption || '',
        link: fig.dataset.pgLink || '',
        ar: parseFloat(fig.dataset.pgAr) || 1
      };
    });
  }

  function init(root) {
    if (root.dataset.pgReady === 'true') return;

    var dialog = root.querySelector('[data-pg-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var photos = collect(root);
    if (!photos.length) return;

    root.dataset.pgReady = 'true';

    var stage = dialog.querySelector('[data-pg-lb-stage]');
    var captionEl = dialog.querySelector('[data-pg-lb-caption]');
    var counterEl = dialog.querySelector('[data-pg-lb-counter]');
    var linkEl = dialog.querySelector('[data-pg-lb-link]');
    var index = 0;
    var lastTrigger = null;

    // Neighbours are fetched ahead so arrowing through does not flash white.
    function preload(i) {
      var p = photos[(i + photos.length) % photos.length];
      if (p && p.src) {
        var im = new Image();
        if (p.srcset) im.srcset = p.srcset;
        im.src = p.src;
      }
    }

    function render(i) {
      index = (i + photos.length) % photos.length;
      var p = photos[index];

      stage.innerHTML = '';
      if (p.src) {
        var img = document.createElement('img');
        img.className = 'pg__lb-image';
        img.alt = p.alt;
        img.sizes = '92vw';
        if (p.srcset) img.srcset = p.srcset;
        img.src = p.src;
        stage.appendChild(img);
      } else {
        // Placeholder blocks, i.e. the gallery before the photography lands.
        // Cycling still works, which is the point of previewing it at all.
        var ph = document.createElement('div');
        ph.className = 'pg__lb-placeholder';
        ph.style.aspectRatio = String(p.ar);
        stage.appendChild(ph);
      }

      captionEl.textContent = p.caption;
      captionEl.hidden = !p.caption;

      counterEl.textContent = index + 1 + ' / ' + photos.length;

      if (linkEl) {
        if (p.link) {
          linkEl.href = p.link;
          linkEl.hidden = false;
        } else {
          linkEl.removeAttribute('href');
          linkEl.hidden = true;
        }
      }

      preload(index + 1);
      preload(index - 1);
    }

    /*
      Cleanup is driven from here rather than from the dialog's own 'close'
      event. That event was observed not to fire at all in testing — showModal()
      and close() both worked and dialog.open flipped correctly, but no close or
      cancel event was ever dispatched, in the page world or an injected one.
      Depending on it would have left the stage populated and focus lost.

      Every exit routes through this function; the 'close' listener below stays
      as a belt-and-braces path for browsers that do fire it, and the work is
      idempotent so running twice is harmless.
    */
    function dismiss() {
      if (dialog.open) dialog.close();
      stage.innerHTML = '';
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-pg-open]'), function (btn) {
      btn.addEventListener('click', function () {
        lastTrigger = btn;
        render(parseInt(btn.getAttribute('data-pg-open'), 10));
        dialog.showModal();
      });
    });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // Handled here too: the native close would otherwise skip cleanup,
        // since this browser does not dispatch the close event.
        e.preventDefault();
        dismiss();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        render(index + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        render(index - 1);
      } else if (e.key === 'Home') {
        e.preventDefault();
        render(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        render(photos.length - 1);
      }
    });

    dialog.querySelector('[data-pg-lb-next]').addEventListener('click', function () {
      render(index + 1);
    });
    dialog.querySelector('[data-pg-lb-prev]').addEventListener('click', function () {
      render(index - 1);
    });
    dialog.querySelector('[data-pg-lb-close]').addEventListener('click', dismiss);

    // A click that lands on the dialog itself is a click on the backdrop area
    // around the photo — the figure and the controls stop their own.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dismiss();
    });

    dialog.addEventListener('close', dismiss);
    dialog.addEventListener('cancel', dismiss);

    var swipeX = null;
    dialog.addEventListener(
      'touchstart',
      function (e) {
        swipeX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );
    dialog.addEventListener(
      'touchend',
      function (e) {
        if (swipeX === null) return;
        var dx = e.changedTouches[0].clientX - swipeX;
        if (Math.abs(dx) > 40) render(index + (dx < 0 ? 1 : -1));
        swipeX = null;
      },
      { passive: true }
    );
  }

  function initAll(scope) {
    var node = scope && scope.querySelectorAll ? scope : document;
    if (node.matches && node.matches('[data-pg-root]')) init(node);
    Array.prototype.forEach.call(node.querySelectorAll('[data-pg-root]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: a re-rendered section arrives with a fresh, uninitialised DOM.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
